import { render } from "./PaymentUnfinished.vue?vue&type=template&id=3988e910&scoped=true"
import script from "./PaymentUnfinished.vue?vue&type=script&lang=js"
export * from "./PaymentUnfinished.vue?vue&type=script&lang=js"

import "./PaymentUnfinished.vue?vue&type=style&index=0&id=3988e910&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3988e910"]])

export default __exports__